export const constants = {
  ASYNC_STORAGE_KEYS: {
    UNIQUE_USER_ID: "unique user id",
    DISABLE_LANGUAGE_REDIRECTS: "disable language redirects",
    PREFERRED_LANGUAGE_ON_MOBILE: "preferred language on mobile",
    // This keys are used to prefill user data in the main page form
    NAME: "name",
    AGE: "age",
    SEX: "sex",

    IS_LOGGED_IN_IOS: "is logged in ios",
  },
  DEFAULT_LANGUAGE: "en" as const,
} as const;
